import { Breakpoints, Layout, LayoutRowGap, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import { bonoPosventaBackgroundColor } from '../../../../../../../helpers/color-tokens';
import { BonoCardBackground } from '../../../../shared/ui/bono-card-backgound';
import { PopupBonoPosventaCardC1 } from './popup-bono-posventa-card-c1';
import { PopupBonoPosventaCardC2 } from './popup-bono-posventa-card-c2';

export const PopupBonoPosventaCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<BonoCardBackground
			bgColor={bonoPosventaBackgroundColor}
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="bono-posventa-card-container"
			wrap={{
				[Breakpoints.default]: 'never',
			}}
		>
			<ThemeProvider theme="inverted">
				<Layout
					data-testid="hucha-card-layout"
					rowGap={LayoutRowGap.dynamic0130}
					appearance={{
						[Breakpoints.default]: [
							{ name: 'bono-posventa-popup-card-c2', columns: 24 },
							{ name: 'bono-posventa-popup-card-c3', columns: 24 },
						],
						[Breakpoints.b960]: [
							{ name: 'bono-posventa-popup-card-c2', columns: 11 },
							{ name: '.', columns: 1 },
							{ name: 'bono-posventa-popup-card-c3', columns: 12 },
						],
						[Breakpoints.b1280]: [
							{ name: 'bono-posventa-popup-card-c2', columns: 11 },
							{ name: '.', columns: 2 },
							{ name: 'bono-posventa-popup-card-c3', columns: 11 },
						],
					}}
				>
					<PopupBonoPosventaCardC1 />
					<PopupBonoPosventaCardC2 dineroHucha={dineroHucha} />
				</Layout>
			</ThemeProvider>
		</BonoCardBackground>
	);
};
